import { isTypeHeroQuoteSection } from '@platform/contentful';
import cx from 'classix';
import { Entry } from 'contentful';

const ContentfulHeroQuoteSection = ({
  entry,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry: Entry<any, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeHeroQuoteSection(entry)) {
    return null;
  }

  return (
    <div
      className='flex flex-col justify-center -mx-4.5 py-6 sm:py-12  min-h-[75vh]'
      style={{
        backgroundImage: `url(${entry.fields.image?.fields.file?.url})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'left',
      }}
    >
      <div
        className={cx(
          'flex flex-col bg-white sm:max-w-2/4 px-8 pb-6',
          'mx-6',
          entry.fields.cardAlignment === 'Left' ? 'sm:ml-auto sm:mr-[10%]' : 'sm:ml-[10%] sm:mr-6',
        )}
      >
        <blockquote className='text-gray-700 text-2xl sm:text-3xl leading-7 sm:leading-10 italic '>
          <p className='leading-7 sm:leading-10 italic'>{entry.fields.quote}</p>
        </blockquote>
        <div className='font-header text-xl sm:text-2xl leading-6 sm:leading-7 text-gray-500 text-right'>
          - {entry.fields.quotee}
        </div>
      </div>
    </div>
  );
};

export default ContentfulHeroQuoteSection;
